(() => {
  const fixRatings = (root = document) => {
    root.querySelectorAll?.('.rating-star:not(.fds-rating-fixed)').forEach((el) => {
      const whole = Number.parseFloat(el.style.getPropertyValue('--rating')) || 0;
      const decimal = Number.parseFloat(el.style.getPropertyValue('--rating-decimal')) || 0;
      const max = Number.parseFloat(el.style.getPropertyValue('--rating-max')) || 5;
      const value = Math.max(0, Math.min(max, whole + decimal));
      el.style.setProperty('--fds-rating-percent', `${(value / max) * 100}%`);
      el.classList.add('fds-rating-fixed');
    });
  };

  const lineMenus = {
    trichofirst: 'Linea tricologica della Farmacia dei Sali dedicata alla cura dei capelli e del cuoio capelluto.',
    'oloma-nutrition': 'Linea di integratori pensata per supportare le principali esigenze quotidiane di benessere.'
  };

  const ensureMenuStyles = () => {
    if (document.getElementById('fds-line-menu-styles')) return;
    const style = document.createElement('style');
    style.id = 'fds-line-menu-styles';
    style.textContent = `
      .fds-menu-line-intro{padding-top:1.7rem;padding-bottom:.2rem}
      .fds-menu-line-intro p{max-width:72rem;margin:0;color:rgba(37,37,37,.68);font-size:1.42rem;line-height:1.45}
      @media screen and (min-width:990px){
        .fds-menu-products-grid{grid-template-columns:repeat(4,minmax(0,1fr))!important;gap:.45rem 2.4rem!important;padding-top:1.2rem!important}
        .fds-menu-products-grid .mega-menu__link--level-2{padding:.65rem 0!important;font-size:1.35rem!important;line-height:1.3}
      }
      @media screen and (max-width:989px){
        .fds-menu-line-intro-mobile{margin:0;padding:.35rem 3.2rem 1.25rem;color:rgba(37,37,37,.68);font-size:1.34rem;line-height:1.45}
        .fds-line-menu-drawer>.menu-drawer__menu .menu-drawer__menu-item{padding-top:1rem;padding-bottom:1rem;font-size:1.45rem;line-height:1.25}
      }
    `;
    document.head.appendChild(style);
  };

  const directDetailsFor = (trigger, selector = 'details') => {
    if (!trigger || trigger.tagName !== 'SUMMARY') return null;
    const parent = trigger.parentElement;
    return parent?.matches?.(selector) ? parent : null;
  };

  const decorateLineMenus = (root = document) => {
    ensureMenuStyles();
    const scope = root?.querySelector ? root : document;

    Object.entries(lineMenus).forEach(([handle, description]) => {
      const desktopTrigger = scope.querySelector(`#HeaderMenu-${handle}`) || document.querySelector(`#HeaderMenu-${handle}`);
      const desktopDetails = directDetailsFor(desktopTrigger, 'details.mega-menu');
      const desktopContent = desktopDetails?.querySelector('.mega-menu__content');
      const desktopList = desktopContent?.querySelector('.mega-menu__list');

      if (desktopContent && !desktopContent.querySelector('.fds-menu-line-intro')) {
        const intro = document.createElement('div');
        intro.className = 'fds-menu-line-intro page-width';
        const p = document.createElement('p');
        p.textContent = description;
        intro.appendChild(p);
        desktopContent.insertBefore(intro, desktopList || desktopContent.firstChild);
      }
      desktopList?.classList.add('fds-menu-products-grid');

      const mobileTrigger = scope.querySelector(`#HeaderDrawer-${handle}`) || document.querySelector(`#HeaderDrawer-${handle}`);
      const mobileDetails = directDetailsFor(mobileTrigger, 'details');
      const mobileInner = mobileDetails?.querySelector('.menu-drawer__inner-submenu');
      const backButton = mobileInner?.querySelector('.menu-drawer__close-button');

      if (mobileInner) {
        mobileInner.classList.add('fds-line-menu-drawer');
        if (!mobileInner.querySelector('.fds-menu-line-intro-mobile')) {
          const intro = document.createElement('p');
          intro.className = 'fds-menu-line-intro-mobile';
          intro.textContent = description;
          if (backButton) backButton.insertAdjacentElement('afterend', intro);
          else mobileInner.prepend(intro);
        }
      }
    });
  };

  const init = () => {
    fixRatings(document);
    decorateLineMenus(document);
    const target = document.getElementById('MainContent') || document.body;
    if (!target) return;
    new MutationObserver(() => fixRatings(document)).observe(target, { childList: true, subtree: true });
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init, { once: true });
  } else {
    init();
  }

  document.addEventListener('shopify:section:load', (event) => {
    fixRatings(event.target);
    decorateLineMenus(event.target);
  });
})();
